import { DivolteEvent } from '@/app/modules/Metrics/loaders/ClickStream';

export enum CSCEVENT {
    AUTH = 'authEvent',
    BANNER = 'bannerEvent',
    BUTTON = 'buttonClick',
    PAGE = 'pageView',
    SERVICE = 'serviceEvent',
}

export class DivolteHolder implements DivolteEvent {
    /**
     *
     * @param type          Event Type
     * @param ObjEventType  Модификатор события
     * @param ObjName       Контекст события
     * @param ObjVal        Контейнер для кастомного значения
     * @param rewriteParameters Специальный объект, позволяющий перезаписать любой параметр запроса
     */
    constructor(
        public type: CSCEVENT,
        public ObjEventType: string,
        public ObjName?: string,
        public ObjVal?: any,
        public rewriteParameters?: Record<string, any>
    ) {}
}

/**
 * Shortcut
 */
export const _D = function (
    type: CSCEVENT,
    ObjEventType: string,
    ObjName?: string,
    ObjVal?: any,
    rewriteParameters?: Record<string, any>
): DivolteEvent {
    return new DivolteHolder(
        type,
        ObjEventType,
        ObjName,
        ObjVal,
        rewriteParameters
    );
};
